<template>
  <div>
    <ambassadors-list />
  </div>
</template>

<script>
  import AmbassadorsList from '@/components/recherche/ambassadors/AmbassadorsList.vue'

  export default {
    components: {
      AmbassadorsList
    }
  }
</script>
